// extracted by mini-css-extract-plugin
module.exports = {"hero":"_3MZlr","hero_icon":"_35EZk"};